import { createContext, useContext } from 'react'

export const StepperContext = createContext<any>({})

export const useStepperContext = () => {
  const context = useContext(StepperContext)
  return context
}
